window.app = window.app || {};

window.app.modal = {
  body: document.querySelector('body'),
  modals: document.querySelectorAll('.mt-modal'),
  modalsIds: [],
  modalVisible: false,

  open: function(modal = null) {
    const _this = app.modal;
    if (modal === null || this.modalVisible) return;
    if (modal.id === 'market-modal' && window.sessionStorage.getItem('mt-market-modal') !== null) return;

    modal.classList.add('visible');
    _this.body.classList.add('mt-modal-active');
    _this.modalVisible = true;
  },

  close: function(modal = null) {
    const _this = app.modal;
    if (modal === null) return;

    // Lightbox
    if (modal.id === 'lightbox') {
      const video = modal.querySelector('video');
      const ytVideo = modal.querySelector('#yt-lightbox');
      video && video.pause();
      ytVideo && document.dispatchEvent(new CustomEvent('mt-lightbox-closed', {}));
    }

    // Market
    if (modal.id === 'market-modal') window.sessionStorage.setItem('mt-market-modal', 1);

    // TH Activity
    if (modal.id === 'activity-modal') {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete('aid') ;
      history.pushState({}, "", currentUrl);
    }

    // Video Lightbox
    if (modal.id === 'lightbox' && window.location.href.includes('academy')) {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete('video') ;
      history.pushState({}, "", currentUrl);
    }

    modal.classList.remove('visible');
    _this.body.classList.remove('mt-modal-active');
    _this.modalVisible = false;
  },

  init: function() {
    const _this = this;
    if (_this.modals.length === 0) return;

    _this.modals.forEach(modal => {
      const el = {
        overlay: modal.querySelector('.mt-modal__overlay'),
        close: modal.querySelectorAll('.mt-modal-close, [data-close-modal]')
      };

      // Get modal ID
      (modal.id != '') && _this.modalsIds.push(modal.id);

      // Events
      [el.overlay, ...el.close].forEach(el => {
        el.addEventListener('click', e => {
          e.preventDefault();
          _this.close(modal);
        });
      });
      modal.addEventListener('keydown', e => {
        e = e || window.event;
        if (e.keyCode === 27) {
          _this.close(modal);
        }
      });

      // Market modal auto-open
      (modal.id == 'market-modal') && _this.open(modal);
    });

    // Open modal via links
    document.addEventListener('click', e => {
      const closestLink = e.target.closest('a');
      if (e.target.matches('[href^="#"]') || closestLink?.matches('[href^="#"]')) {
        const modalId = (e.target.hash || closestLink?.hash).replace('#', '');
        const modal = document.getElementById(modalId);
    
        if (modal && _this.modalsIds.includes(modalId)) {
          e.preventDefault();
          _this.open(modal);
        }
      }
    });

    // Close modals with keyboard
    document.addEventListener('keydown', e => {
      const activeModal = document.querySelector('.mt-modal.visible');
      (e.key === 'Escape' && activeModal) && _this.close(activeModal);

      if (activeModal && activeModal.id === 'activity-modal') {
        const gallery = document.querySelector('.mt-activity-gallery');
        (e.key == 'ArrowRight') && gallery.swiper?.slideNext();
        (e.key == 'ArrowLeft') && gallery.swiper?.slidePrev();
      }
    });
  }
}
window.app.modal.init();